
import React, { useEffect, useState } from 'react';
import { useAuthStore } from '@/stores/auth-store';
import { LoginForm } from '@/components/auth/login-form';
import { Loader2 } from 'lucide-react';
import { appConfig } from '@/config/app-config';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated, isLoading, restoreSession } = useAuthStore();
  const [isRestoring, setIsRestoring] = useState(true);
  const [configError, setConfigError] = useState<string | null>(null);

  useEffect(() => {
    const restore = async () => {
      // Load runtime config from Worker /config endpoint FIRST
      // This ensures odooUrl and odooDb are available for login
      try {
        await appConfig.loadConfig();
      } catch (err) {
        console.error('[AuthGuard] Failed to load runtime config:', err);
      }

      if (!appConfig.isConfigured) {
        setConfigError('لم يتم تحميل إعدادات الاتصال. تأكد من تشغيل سيرفر API على البورت 8787');
      }

      await restoreSession();
      setIsRestoring(false);
    };
    restore();
  }, []);

  if (isRestoring || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <Loader2 className="w-8 h-8 text-primary animate-spin mx-auto" />
          <p className="text-sm text-muted-foreground">جاري التحقق من الجلسة...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div>
        {configError && (
          <div className="fixed top-0 left-0 right-0 z-50 bg-destructive text-destructive-foreground px-4 py-2 text-center text-sm">
            ⚠️ {configError}
          </div>
        )}
        <LoginForm />
      </div>
    );
  }

  return <>{children}</>;
};
